<template>
	<van-popup v-model="show" :position="isMobileFlag?'bottom':'center'" get-container="body" closeable
		class="bs-popup">
		<div class="bs-popup-head">
			<div class="bs-popup-tit">
				{{$t('修改登录密码')}}
			</div>
		</div>
		<div class="bs-popup-scroll">
			<div class="bs-popup-body">
				<el-form ref="form" :model="form">
					<el-form-item >
						<el-input v-model="form.old_pwd" :placeholder="$t('请输入原密码')"></el-input>
					</el-form-item>
					<el-form-item >
						<el-input v-model="form.new_pwd" :placeholder="$t('请输入新密码')"></el-input>
					</el-form-item>
					<el-form-item >
						<el-input v-model="form.confirm_pwd" :placeholder="$t('请二次输入新密码')" ></el-input>
					</el-form-item>
					<el-row :gutter="20" class="btn-foot-row">
						<el-col :span="12">
							<el-button round  type="warning" @click="show = false">
								{{$t('取消')}}
							</el-button>
						</el-col>
						<el-col :span="12">
							<el-button round type="primary" @click="onSubmit">
								{{$t('确定')}}
							</el-button>
						</el-col>
					</el-row>	
				</el-form>
			</div>
		</div>
	</van-popup>

</template>
<script>
	import {change_pwd_api} from "@/api/user"
	export default {
		components: {},
		data() {
			return {
				show: false,
				form: {
					old_pwd: '',
					new_pwd: '',
					confirm_pwd: '',
				}
			};
		},
		methods: {
		  async onSubmit() {
		    try {
		      if (this.form.old_pwd == "") {
		        this.errorTips(this.$t("请输入原密码"));
		        return false;
		      }
		      if (this.form.new_pwd == "") {
		        this.errorTips(this.$t("请输入新密码"));
		        return false;
		      }
		      if (this.form.confirm_pwd == "") {
		        this.errorTips(this.$t("请二次输入新密码"));
		        return false;
		      }
		      
		      let param = {
		        old_pwd: this.form.old_pwd,
		        new_pwd: this.form.new_pwd,
		        confirm_pwd: this.form.confirm_pwd,
		      };
		      
		      const loading = this.$loading({
		        lock: true,
		        text: '',
		        spinner: 'loader',
		        background: 'rgba(255, 255, 255, 0.3)'
		      });
		      
		      const res = await change_pwd_api(param);
		      loading.close();
		      if (res && res.data && res.data.code == 1) {
		        this.$message.success(res.data.msg);
		        this.show = false;
		      } else {
		        this.errorTips(res.data && res.data.msg || this.$t('修改密码失败'));
		      }
			  this.form.old_pwd = ""
			  this.form.new_pwd = ""
			  this.form.confirm_pwd = ""
		    } catch (error) {
		      console.log('修改密码时出错:', error);
		    }
		  }
		},

		mounted() {}
	}
</script>
<style scoped>
	.btn-foot-row{
		padding: 10px 0;
	}
	.btn-foot-row .el-button{
		width: 100%;
	}
</style>